// extracted by mini-css-extract-plugin
module.exports = {"SliderBullets":"styles_SliderBullets__14Ovl","bullet":"styles_bullet__3tTCM","isActive":"styles_isActive__1qds6"};